/* eslint-disable import/order */
import React, { useState, useRef, useMemo } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import User from '../../../services/bioplus-services/user';
import { useUserContext } from '../../../hooks/UserContext';
import { useCompany } from '../../../hooks/CompanyContext';
import { Label } from '../../../Components/uielements';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
// import Company from '../../../services/bioplus-services/company';
import {
  NavBarDropDown,
  NavBarDropDownRow,
  NavBarDropDownRowLeft,
  LoutoutRow,
  UserDropDown,
  StyledNavBar,
  UserDropDownContainer,
  NavBarLeft,
  NavBarLeftLogo,
  NavItemRow,
  NavBarRight,
  NavItem,
  NavBarIconContainer,
  // TooltipWrapper,
  UserName,
  MobileHamburger,
  MobileMenu,
  MobileMenuHeader,
  MobileNavList,
  MobileNavItem,
  MobileNavItemHeader,
  MobileSubNavList,
  MobileSubNavItem,
  MobileChevron,
  MobileOverlay,
} from './navbar.style';
import {
  ChangeLangSvg,
  ChevronDownWhite,
  CustomerSupportSvg,
  TermsAndConditions,
  UserDefaultImg,
} from '../../../Components/icons';
import PolicyIcon from '@mui/icons-material/Policy';
import { screenSizes } from '../../../helper/styleHelper';
import { useMediaQuery } from 'react-responsive';
import useOutsideClick from '../../../hooks/useOutsideClick';
import AgManagerLogo from '../../../assets/PNG/AGMLogoWheat.png';
import { useLocation, useNavigate } from 'react-router-dom';
import CompanyFilter from './companyFilter';
import UserRoleSwitch from './userRoleSwitch';
import { IntlMessages } from '../../../helper/langHelper';
import DropDown from '../../../Components/uielements/dropDown';
import { useLanguage } from '../../../hooks/useLanguageSwitch';
import LinksModal from '../../Pages/DashboardV2/modals/linksModal';
// import { TwoColumns } from '../../../services/settings/appStyle/global.style';
import { filterEmployeeData } from './helper';
import { TooltipTarget } from '../../../Components/uielements/tooltip/tooltip.style';
import { InviteUserModal, InviteVisitorModal, InviteFriendModal } from '../../Pages/UserV2/modals';
import { activeNavState } from '../../../services/constant/constant';
import { useAuth } from '../../../hooks/AuthContext';
import SupportModal from './supportModal';

const NavbarComponent = ({ menuData, userInfo, isPartner = false, isOwner = false, role }) => {
  const isXxl = useMediaQuery({ minWidth: screenSizes.xxl });
  const isHdScreen = useMediaQuery({ minWidth: screenSizes.vxxl });
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const languageChanged = useLanguage();
  const [isShowLinksModal, setIsShowLinksModal] = useState(false);
  const [inviteNavState, setInviteNavState] = useState(undefined);
  const userContext = useUserContext();
  const userRole = userContext?.company;
  const companyId = userRole?.companyId?.id;
  const profileImage = userContext?.user?.profileImg;

  const { userPermission } = userContext;
  const isCustomerAllowToManage = userPermission?.find(
    (permission) => permission?.label === 'customer'
  );
  const isViewCompanyFilter = !!isCustomerAllowToManage?.isView;

  // const companyQuery = useQuery(['company', companyId], () => Company.getCompany(companyId));

  const subMenu = useRef(null);
  const organizationRef = useRef(null);
  const queryClient = useQueryClient();

  const { logout } = useAuth();

  const handleVisitorLogout = () => {
    queryClient.clear();
    logout();

    navigate('/');
  };
  // const [activeTab, setActiveTab] = useState('/');
  const [isShowDropDown, setIsShowDropDown] = useState(false);
  const [clickTab, setClickTab] = useState('');
  const [isShowUserDropDown, setIsShowUserDropDown] = useState(false);
  const [isShowSupportModal, setIsShowSupportModal] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [mobileExpandedLabel, setMobileExpandedLabel] = useState(null);

  const recordsPath = ['/attendance', '/sos', '/notifications', '/logrecords'];
  const recordsPathForAdmin = ['/users', '/premises', '/geofences', '/companies'];

  useOutsideClick({
    isOpen: isShowDropDown,
    node: subMenu,
    onOutsideClick: () => setIsShowDropDown(false),
  });

  useOutsideClick({
    isOpen: isShowUserDropDown,
    node: organizationRef,
    onOutsideClick: () => setIsShowUserDropDown(false),
  });

  const isMobile = useMediaQuery({ maxWidth: screenSizes.md - 1 });
  const isTablet = useMediaQuery({ minWidth: screenSizes.md, maxWidth: screenSizes.lg - 1 });
  // Mobile AND tablet both collapse into the hamburger / drawer experience.
  const isCompact = isMobile || isTablet;

  const handleSetSelectedLangIntoLocalStorage = (lang) => {
    if (lang) {
      languageChanged.setLanguage(lang.value);
    }
  };

  const handleOpenSupportModal = () => {
    setIsShowSupportModal(true);
  };

  const renderDropdown = (options) => {
    return (
      <NavBarDropDown
        isBottom={
          isPartner
            ? isXxl
              ? '-205px'
              : isHdScreen
              ? '-205px'
              : '-205px'
            : isXxl
            ? '-205px'
            : isHdScreen
            ? '-205px'
            : '-205px'
        }
      >
        <div style={{ paddingTop: '10px' }}></div>
        {options.map((option) => (
          <div>
            {option.click ? (
              <NavBarDropDownRow
                key={option.label}
                onClick={() => setInviteNavState(option?.value)}
              >
                <Label cursor="pointer" color="normal">
                  {option.label}
                </Label>
              </NavBarDropDownRow>
            ) : (
              <NavBarDropDownRow key={option.label} onClick={() => navigate(option.page)}>
                <Label cursor="pointer" color="normal">
                  {option.label}
                </Label>
              </NavBarDropDownRow>
            )}
          </div>
        ))}
        <div style={{ paddingBottom: '10px' }}></div>
      </NavBarDropDown>
    );
  };

  const handleItemClick = (item) => {
    // setActiveTab(item.page);
    if (!item.subOptions) {
      navigate(item.page);
      setIsShowDropDown(false);
    } else {
      setIsShowDropDown(!isShowDropDown);
      setClickTab(item?.label);
    }
  };

  const handleNavigateToPrivacyPage = () => {
    window.open('https://agmanager.com.au/privacy-policy/', '_blank');
  };
  const handleNavigateToTermsAndConditionsPage = () => {
    window.open('https://agmanager.com.au/terms-and-conditions/', '_blank');
  };

  const renderNavItem = (item, role) => {
    return (
      <>
        {item.subOptions && item?.subOptions?.length > 0 ? (
          <NavItem
            key={item.label}
            onClick={() => {
              handleItemClick(item);
            }}
            isDropDown={item.isOpen}
          >
            <NavBarIconContainer
              isAcitveTab={
                item.isRecord
                  ? recordsPath.includes(pathname)
                  : item?.isInvite
                  ? inviteNavState
                  : recordsPathForAdmin.includes(pathname)
              }
            >
              {item.label}
            </NavBarIconContainer>
            {item.subOptions && <ChevronDownWhite />}
            {item.subOptions &&
              isShowDropDown &&
              clickTab === item.label &&
              renderDropdown(item.subOptions)}
          </NavItem>
        ) : item?.isLinks ? (
          <>
            <NavItem
              key={item.label}
              onClick={() => {
                setIsShowLinksModal(true);
              }}
              isDropDown={item.isOpen}
              isAcitveTab={pathname === item.page}
            >
              <NavBarIconContainer isAcitveTab={pathname === item.page}>
                {item.label}
              </NavBarIconContainer>
            </NavItem>
          </>
        ) : (
          <NavItem
            key={item.label}
            onClick={() => {
              handleItemClick(item);
            }}
            isDropDown={item.isOpen}
            isAcitveTab={pathname === item.page}
            // isPartner={'PARTNER' === role}
          >
            <NavBarIconContainer isAcitveTab={pathname === item.page}>
              {item.subOptions && item?.subOptions?.length === 0 ? null : <>{item.label}</>}
            </NavBarIconContainer>
          </NavItem>
        )}
      </>
    );
  };

  // const company = companyQuery.data;
  const renderUserDropdown = () => {
    return (
      <>
        <UserDropDown className="hide-scroll-bar">
          <div style={{ paddingTop: '10px' }}></div>
          <NavBarDropDownRow>
            <NavBarDropDownRowLeft>
              <UserRoleSwitch user={userInfo} />
              <TooltipTarget onClick={handleOpenSupportModal}>
                <CustomerSupportSvg style={{ width: '20px', height: '20px' }} />
                <UserName>
                  <IntlMessages id="toolTip.title" />
                </UserName>
              </TooltipTarget>
              <TooltipTarget onClick={handleNavigateToPrivacyPage}>
                <PolicyIcon style={{ width: '20px', height: '20px' }} />
                <UserName>
                  <IntlMessages id="title.privacy.policy" />
                </UserName>
              </TooltipTarget>
              <TooltipTarget onClick={handleNavigateToTermsAndConditionsPage}>
                <TermsAndConditions style={{ width: '20px', height: '20px' }} />
                <UserName>
                  <IntlMessages id="title.terms.conditions" />
                </UserName>
              </TooltipTarget>
            </NavBarDropDownRowLeft>
          </NavBarDropDownRow>

          <LoutoutRow>
            <Label cursor="pointer" color="normal">
              {role === 'VISITOR' ? (
                <NavBarIconContainer onClick={handleVisitorLogout}>
                  <LogoutIcon /> <IntlMessages id="nav.drop.down.signOut" />
                </NavBarIconContainer>
              ) : (
                <NavBarIconContainer onClick={() => navigate('/signout')}>
                  <LogoutIcon />
                  <IntlMessages id="nav.drop.down.signOut" />
                </NavBarIconContainer>
              )}
            </Label>
          </LoutoutRow>
        </UserDropDown>
      </>
    );
  };

  // Toggle a top-level item's accordion inside the mobile/tablet drawer.
  const handleMobileParentClick = (item) => {
    if (item.subOptions && item.subOptions.length > 0) {
      setMobileExpandedLabel((prev) => (prev === item.label ? null : item.label));
      return;
    }
    if (item.isLinks) {
      setIsShowLinksModal(true);
      setIsMobileMenuOpen(false);
      return;
    }
    if (item.page) {
      navigate(item.page);
      setIsMobileMenuOpen(false);
    }
  };

  const handleMobileSubClick = (sub) => {
    if (sub.click) {
      setInviteNavState(sub?.value);
    } else if (sub.page) {
      navigate(sub.page);
    }
    setIsMobileMenuOpen(false);
    setMobileExpandedLabel(null);
  };

  return (
    <StyledNavBar ref={subMenu}>
      {/* Mobile & tablet: hamburger on the left, no logo needed */}
      {isCompact && (
        <MobileHamburger aria-label="Open menu" onClick={() => setIsMobileMenuOpen((s) => !s)}>
          <MenuIcon />
        </MobileHamburger>
      )}

      {!isCompact && <NavBarLeftLogo src={AgManagerLogo} alt="AgManager Logo" />}

      {/* Desktop nav only (hidden on mobile & tablet) */}
      {!isCompact ? (
        <NavBarLeft>
          <NavItemRow>
            {menuData.map((item) => (
              <React.Fragment key={item.label}>{renderNavItem(item, role)}</React.Fragment>
            ))}
          </NavItemRow>
        </NavBarLeft>
      ) : null}

      <NavBarRight ref={organizationRef}>
        {/* Language switcher & company filter only show on desktop (lg and up) */}
        {!isCompact && (
          <>
            <DropDown
              options={[
                {
                  value: 'English',
                  label: 'English',
                  icon: <ChangeLangSvg style={{ width: '20px', height: '20px' }} />,
                },
                {
                  value: 'Portuguese',
                  label: 'Portuguese',
                  icon: <ChangeLangSvg style={{ width: '20px', height: '20px' }} />,
                },
              ]}
              selectedOption={handleSetSelectedLangIntoLocalStorage}
              notRequireLabel={true}
              label={
                languageChanged?.selectedLang ? languageChanged?.selectedLang : 'Choose Language'
              }
              width="150px"
            />
            {isViewCompanyFilter && <CompanyFilter />}
          </>
        )}
        <UserDropDownContainer
          isShowIcon
          isDropDown={true}
          onClick={() => {
            setIsShowUserDropDown(!isShowUserDropDown);
            setIsShowDropDown(false);
          }}
        >
          {profileImage ? (
            <img
              src={profileImage}
              alt="Member profile"
              style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                objectFit: 'cover',
              }}
            />
          ) : (
            <UserDefaultImg />
          )}
        </UserDropDownContainer>
        {isShowUserDropDown ? <>{renderUserDropdown()}</> : null}
        {isShowLinksModal && <LinksModal onClose={() => setIsShowLinksModal(false)} />}

        {inviteNavState === activeNavState.addUser && (
          <InviteUserModal onClose={() => setInviteNavState(undefined)} companyId={companyId} />
        )}
        {inviteNavState === activeNavState.inviteGuest && (
          <InviteVisitorModal onClose={() => setInviteNavState(undefined)} companyId={companyId} />
        )}

        {inviteNavState === activeNavState.inviteFriend && (
          <InviteFriendModal onClose={() => setInviteNavState(undefined)} />
        )}
        {isShowSupportModal && <SupportModal onClose={() => setIsShowSupportModal(false)} />}
      </NavBarRight>

      {/* Mobile / tablet drawer */}
      {isCompact && isMobileMenuOpen && (
        <>
          <MobileOverlay onClick={() => setIsMobileMenuOpen(false)} />
          <MobileMenu>
            <MobileMenuHeader>
              <img src={AgManagerLogo} alt="AgManager Logo" style={{ width: 140, height: 33 }} />
              <button
                aria-label="Close menu"
                onClick={() => setIsMobileMenuOpen(false)}
                style={{ background: 'transparent', border: 'none', color: '#fff', fontSize: 20 }}
              >
                ✕
              </button>
            </MobileMenuHeader>
            <MobileNavList>
              {menuData.map((item) => {
                const hasChildren = item.subOptions && item.subOptions.length > 0;
                const isExpanded = mobileExpandedLabel === item.label;
                const isActive = item.page && pathname === item.page;

                return (
                  <MobileNavItem key={item.label} isExpanded={isExpanded}>
                    <MobileNavItemHeader
                      isActive={isActive}
                      onClick={() => handleMobileParentClick(item)}
                    >
                      <div>{item.label}</div>
                      {hasChildren && (
                        <MobileChevron isExpanded={isExpanded}>
                          <ChevronDownWhite />
                        </MobileChevron>
                      )}
                    </MobileNavItemHeader>

                    {hasChildren && (
                      <MobileSubNavList isExpanded={isExpanded}>
                        {item.subOptions.map((sub) => (
                          <MobileSubNavItem
                            key={sub.label}
                            isActive={sub.page && pathname === sub.page}
                            onClick={() => handleMobileSubClick(sub)}
                          >
                            {sub.label}
                          </MobileSubNavItem>
                        ))}
                      </MobileSubNavList>
                    )}
                  </MobileNavItem>
                );
              })}
            </MobileNavList>
          </MobileMenu>
        </>
      )}
    </StyledNavBar>
  );
};

// --- Nav data builders --------------------------------------------------
// adminData / partnerData are now functions of `hasCompanyFilter` so the
// "Custom Roles" item only appears once a company filter is actually
// selected (matches AdminPartnerCustomRoles, which needs a companyId to
// fetch anything). `.filter(Boolean)` drops the `false` slot left behind
// by the `hasCompanyFilter && {...}` short-circuit.

const getAdminData = (hasCompanyFilter) => [
  { label: <IntlMessages id="nav.dashboard" />, page: '/' },
  {
    label: <IntlMessages id="dashboard.links" />,
    isLinks: true,
  },
  { label: <IntlMessages id="nav.broadcast" />, page: '/broadcast' },
  {
    label: <IntlMessages id="nav.records" />,
    isRecord: true,
    subOptions: [
      {
        label: <IntlMessages id="nav.records.attendance" />,
        page: '/attendance',
        text: 'timesheet',
      },
      {
        label: <IntlMessages id="nav.records.logRecords" />,
        page: '/logrecords',
        text: 'logbook',
      },
    ],
    isOpen: true,
  },
  {
    label: <IntlMessages id="nav.admin" />,
    isAdmin: true,
    subOptions: [
      { label: <IntlMessages id="nav.users" />, page: '/users', text: 'user' },
      { label: <IntlMessages id="nav.roles" />, page: '/roles', text: 'user' },
      hasCompanyFilter && {
        label: <IntlMessages id="nav.customRoles" />,
        page: '/customRoles',
      },
      { label: <IntlMessages id="nav.admins" />, page: '/admins' },
      { label: <IntlMessages id="nav.distributors" />, page: '/distributors', text: 'distributor' },
      { label: <IntlMessages id="account.managers" />, page: '/companies' },
      { label: <IntlMessages id="nav.premises" />, page: '/premises', text: 'premise' },
      { label: <IntlMessages id="nav.geofences" />, page: '/geofences', text: 'geofence' },
      {
        label: <IntlMessages id="user.module.friends" />,
        page: '/friends',
      },
      {
        label: <IntlMessages id="module.declaration.list" />,
        page: '/declarationList',
        text: 'declaration',
      },
      {
        label: <IntlMessages id="module.check.list" />,
        page: '/checkList',
        text: 'checklist',
      },
    ].filter(Boolean),
    isOpen: true,
  },
  {
    label: <IntlMessages id="nav.subscriptionPlans" />,
    page: '/subscription',
  },
  {
    label: <IntlMessages id="module.email.template" />,
    page: '/emailTemplate',
  },
];

const ownerData = [
  { label: <IntlMessages id="nav.dashboard" />, page: '/' },
  {
    label: <IntlMessages id="dashboard.links" />,
    isLinks: true,
  },
  { label: <IntlMessages id="nav.broadcast" />, page: '/broadcast' },
  { label: <IntlMessages id="nav.cvd" />, page: '/cvd', text: 'edec' },
  {
    label: <IntlMessages id="nav.records" />,
    isRecord: true,
    subOptions: [
      {
        label: <IntlMessages id="nav.records.attendance" />,
        page: '/attendance',
        text: 'timesheet',
      },
      { label: <IntlMessages id="nav.records.logRecords" />, page: '/logrecords', text: 'logbook' },
    ],
    isOpen: true,
  },
  {
    label: <IntlMessages id="nav.admin" />,
    isAdmin: true,
    subOptions: [
      { label: <IntlMessages id="nav.users" />, page: '/users', text: 'user' },
      { label: <IntlMessages id="nav.roles" />, page: '/roles', text: 'user' },
      { label: <IntlMessages id="nav.customRoles" />, page: '/customRoles' },
      { label: <IntlMessages id="nav.premises" />, page: '/premises', text: 'premise' },
      { label: <IntlMessages id="nav.geofences" />, page: '/geofences', text: 'geofence' },
      {
        label: <IntlMessages id="user.module.friends" />,
        page: '/friends',
      },
      {
        label: <IntlMessages id="module.declaration.list" />,
        page: '/declarationList',
        text: 'declaration',
      },
      {
        label: <IntlMessages id="module.check.list" />,
        page: '/checkList',
        text: 'checklist',
      },
    ],
    isOpen: true,
  },
];

const DefaultRole = [
  { label: <IntlMessages id="nav.dashboard" />, page: '/' },
  {
    label: <IntlMessages id="dashboard.links" />,
    isLinks: true,
  },
  { label: <IntlMessages id="nav.broadcast" />, page: '/broadcast' },
  { label: <IntlMessages id="nav.cvd" />, page: '/cvd', text: 'edec' },
  {
    label: <IntlMessages id="nav.records" />,
    isRecord: true,
    subOptions: [
      {
        label: <IntlMessages id="nav.records.attendance" />,
        page: '/attendance',
        text: 'timesheet',
      },
      { label: <IntlMessages id="nav.records.logRecords" />, page: '/logrecords', text: 'logbook' },
    ],
    isOpen: true,
  },
  {
    label: <IntlMessages id="nav.admin" />,
    isAdmin: true,
    subOptions: [
      { label: <IntlMessages id="nav.users" />, page: '/users', text: 'user' },
      { label: <IntlMessages id="nav.roles" />, page: '/roles', text: 'user' },
      { label: <IntlMessages id="nav.premises" />, page: '/premises', text: 'premise' },
      { label: <IntlMessages id="nav.geofences" />, page: '/geofences', text: 'geofence' },
      {
        label: <IntlMessages id="user.module.friends" />,
        page: '/friends',
      },
      {
        label: <IntlMessages id="module.declaration.list" />,
        page: '/declarationList',
        text: 'declaration',
      },
      {
        label: <IntlMessages id="module.check.list" />,
        page: '/checkList',
        text: 'checklist',
      },
    ],
    isOpen: true,
  },
];

const visitorData = [
  { label: <IntlMessages id="nav.dashboard" />, page: '/' },
  {
    label: <IntlMessages id="dashboard.links" />,
    isLinks: true,
  },
  {
    label: <IntlMessages id="nav.records" />,
    isRecord: true,
    subOptions: [
      {
        label: <IntlMessages id="nav.records.attendance" />,
        page: '/attendance',
        text: 'timesheet',
      },
      { label: <IntlMessages id="nav.records.logRecords" />, page: '/logrecords', text: 'logbook' },
    ],
    isOpen: true,
  },
  { label: <IntlMessages id="nav.geofences" />, page: '/geofences', text: 'geofence' },
  { label: <IntlMessages id="user.module.friends" />, page: '/friends', text: 'friends' },
];

const getPartnerData = (hasCompanyFilter) => [
  { label: <IntlMessages id="nav.dashboard" />, page: '/' },
  {
    label: <IntlMessages id="dashboard.links" />,
    isLinks: true,
  },
  { label: <IntlMessages id="nav.broadcast" />, page: '/broadcast' },
  {
    label: <IntlMessages id="nav.records" />,
    isRecord: true,
    subOptions: [
      {
        label: <IntlMessages id="nav.records.attendance" />,
        page: '/attendance',
        text: 'timesheet',
      },
      {
        label: <IntlMessages id="nav.records.logRecords" />,
        page: '/logrecords',
        text: 'logbook',
      },
    ],
    isOpen: true,
  },
  {
    label: <IntlMessages id="nav.admin" />,
    isAdmin: true,
    subOptions: [
      { label: <IntlMessages id="nav.users" />, page: '/users', text: 'user' },
      { label: <IntlMessages id="nav.roles" />, page: '/roles', text: 'user' },
      hasCompanyFilter && {
        label: <IntlMessages id="nav.customRoles" />,
        page: '/customRoles',
      },
      { label: <IntlMessages id="nav.distributors" />, page: '/distributors', text: 'distributor' },
      { label: <IntlMessages id="account.managers" />, page: '/companies' },
      { label: <IntlMessages id="nav.premises" />, page: '/premises', text: 'premise' },
      { label: <IntlMessages id="nav.geofences" />, page: '/geofences', text: 'geofence' },
      {
        label: <IntlMessages id="user.module.friends" />,
        page: '/friends',
      },
      {
        label: <IntlMessages id="module.declaration.list" />,
        page: '/declarationList',
        text: 'declaration',
      },
      {
        label: <IntlMessages id="module.check.list" />,
        page: '/checkList',
        text: 'checklist',
      },
    ].filter(Boolean),
    isOpen: true,
  },
  {
    label: <IntlMessages id="nav.subscriptionPlans" />,
    page: '/subscription',
  },
  {
    label: <IntlMessages id="nav.coupon" />,
    page: '/coupon',
  },
];

// const employeeData = [
//   { label: <IntlMessages id="nav.dashboard" />, page: '/' },
//   {
//     label: <IntlMessages id="dashboard.links" />,
//     isLinks: true,
//   },
//   { label: <IntlMessages id="nav.users" />, page: '/users', text: 'user' },
//   {
//     label: <IntlMessages id="nav.premises" />,
//     page: '/premises',
//     text: 'premise',
//   },
//   {
//     label: <IntlMessages id="nav.geofences" />,
//     page: '/geofences',
//     text: 'geofence',
//   },
//   {
//     label: <IntlMessages id="nav.records" />,
//     isRecord: true,
//     subOptions: [
//       {
//         label: <IntlMessages id="nav.records.attendance" />,
//         page: '/attendance',
//         text: 'timesheet',
//       },
//       { label: <IntlMessages id="nav.records.logRecords" />, page: '/logrecords', text: 'logbook' },
//       { label: <IntlMessages id="nav.records.sos" />, page: '/sos', text: 'sos' },
//     ],
//     isOpen: true,
//   },
//   { label: <IntlMessages id="nav.cvd" />, page: '/cvd', text: 'ecvd' },
//   {
//     label: <IntlMessages id="dashboard.links" />,
//     isLinks: true,
//   },
//   {
//     label: <IntlMessages id="nav.invite" />,
//     isInvite: true,
//     subOptions: [
//       {
//         label: <IntlMessages id="nav.add.friend" />,
//         click: true,
//         value: 'invite_friend',
//       },
//       {
//         label: <IntlMessages id="user.module.friends" />,
//         page: '/friends',
//       },
//     ],
//     isOpen: true,
//   },
// ];

const corporateData = [
  { label: <IntlMessages id="nav.dashboard" />, page: '/' },
  { label: <IntlMessages id="nav.users" />, page: '/users', text: 'user' },
  { label: <IntlMessages id="nav.companies" />, page: '/companies' },
  { label: <IntlMessages id="nav.premises" />, page: '/premises', text: 'premise' },
  { label: <IntlMessages id="nav.geofences" />, page: '/geofences', text: 'geofence' },
  {
    label: <IntlMessages id="nav.records" />,
    isRecord: true,
    subOptions: [
      {
        label: <IntlMessages id="nav.records.attendance" />,
        page: '/attendance',
        text: 'attendance',
      },
      { label: <IntlMessages id="nav.records.logRecords" />, page: '/logrecords', text: 'logbook' },
      { label: <IntlMessages id="nav.records.sos" />, page: '/sos', text: 'sos' },
    ],
    isOpen: true,
  },
  { label: <IntlMessages id="nav.cvd" />, page: '/cvd' },
  {
    label: <IntlMessages id="nav.invite" />,
    isInvite: true,
    subOptions: [
      {
        label: <IntlMessages id="nav.add.friend" />,
        click: true,
        value: 'invite_friend',
      },
      {
        label: <IntlMessages id="user.module.friends" />,
        page: '/friends',
      },
    ],
    isOpen: true,
  },
];

const managerData = [
  { label: <IntlMessages id="nav.dashboard" />, page: '/' },
  {
    label: <IntlMessages id="dashboard.links" />,
    isLinks: true,
  },
  { label: <IntlMessages id="nav.broadcast" />, page: '/broadcast' },
  { label: <IntlMessages id="nav.cvd" />, page: '/cvd', text: 'edec' },
  {
    label: <IntlMessages id="nav.records" />,
    isRecord: true,
    subOptions: [
      {
        label: <IntlMessages id="nav.records.attendance" />,
        page: '/attendance',
        text: 'timesheet',
      },
      { label: <IntlMessages id="nav.records.logRecords" />, page: '/logrecords', text: 'logbook' },
    ],
    isOpen: true,
  },
  {
    label: <IntlMessages id="nav.admin" />,
    isAdmin: true,
    subOptions: [
      { label: <IntlMessages id="nav.users" />, page: '/users', text: 'user' },
      { label: <IntlMessages id="nav.roles" />, page: '/roles', text: 'user' },
      { label: <IntlMessages id="nav.premises" />, page: '/premises', text: 'premise' },
      { label: <IntlMessages id="nav.geofences" />, page: '/geofences', text: 'geofence' },
      {
        label: <IntlMessages id="user.module.friends" />,
        page: '/friends',
      },
    ],
    isOpen: true,
  },
];

const NavBar = () => {
  const userQuery = useQuery('self', User.getSelf);
  const userContext = useUserContext();
  const companyContext = useCompany();
  const role = userContext?.company?.role ?? 'VISITOR';
  const { userPermission } = userContext;

  // Same "selected company filter" the admin/partner screens key their
  // queries off (see AdminPartnerCustomRoles). Until this is set, there's
  // no company to scope Custom Roles to, so we hide the nav item entirely
  // instead of sending the user to a page that can't fetch anything yet.
  const hasCompanyFilter = !!companyContext?.company?._id;

  const user = userQuery.data;
  let permissionNavbar;

  if (userPermission) {
    permissionNavbar = filterEmployeeData(DefaultRole, userPermission);
  }

  const adminMenu = useMemo(() => getAdminData(hasCompanyFilter), [hasCompanyFilter]);
  const partnerMenu = useMemo(() => getPartnerData(hasCompanyFilter), [hasCompanyFilter]);

  if (role === 'ADMIN') {
    return (
      <NavbarComponent
        menuData={filterEmployeeData(adminMenu, userPermission)}
        userInfo={user}
        isPartner={true}
        role={role}
      />
    );
  } else if ('PARTNER' === role) {
    return (
      <NavbarComponent
        menuData={filterEmployeeData(partnerMenu, userPermission)}
        userInfo={user}
        isPartner={true}
        role={role}
      />
    );
  } else if (role === 'CORPORATE_ADMIN') {
    return (
      <NavbarComponent
        menuData={filterEmployeeData(corporateData, userPermission)}
        userInfo={user}
      />
    );
  } else if (role === 'OWNER') {
    return (
      <NavbarComponent
        menuData={filterEmployeeData(ownerData, userPermission)}
        userInfo={user}
        isOwner={true}
      />
    );
  } else if (role === 'MANAGER') {
    return (
      <NavbarComponent menuData={filterEmployeeData(managerData, userPermission)} userInfo={user} />
    );
  } else if (role === 'VISITOR') {
    return <NavbarComponent menuData={visitorData} userInfo={user} role="VISITOR" />;
  } else {
    return <NavbarComponent menuData={permissionNavbar || []} userInfo={user} />;
  }
};

export default NavBar;
